import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'reactstrap';
import { compose } from 'recompose';
import styles from './styles.module.scss';

import { preventEnterSubmit } from '../../../../actions/formActions';

import Accordion, { AccordionItem } from '../../../common/Accordion';

import TreatmentResultRecordsStartDetailsSection from '../TreatmentResultRecordsStartDetailsSection';
import TreatmentResultRecordsMonitoringSection from '../TreatmentResultRecordsMonitoringSection';
import TreatmentResultRecordsUncoveringSection from '../TreatmentResultRecordsUncoveringSection';

import { withShowMonitoring } from '../enhancers';
import { withAccordionActiveItemIndex } from './enhancers';
import { connect } from 'react-redux';
//import { withRouter } from 'react-router';
import { withRouter } from '../../../../util/withRouter';
import { getCurrentJob } from '../selectors';
import {
  isExportOtherMBApples,
  isImportOrExportAndContainer,
  isImportOrExportContainerAndMethylBromide,
  isMBLogsInHold,
} from '../../../../util/JobTypeHelper';
import {
  isEthylFormate,
  isSulfurylFlouride,
} from '../../../../util/TreatmentTypeHelper';

const propTypes = {
  handleSubmit: PropTypes.func,
  actions: PropTypes.shape({
    changeFieldValue: PropTypes.func.isRequired,
  }),
  showMonitoring: PropTypes.bool,
  accordionActiveItemIndex: PropTypes.number.isRequired,
};

class TreatmentResultRecordsForm extends Component {


 containerIsUsed(currentJob){
    //returned all used containers
   let trr = currentJob.treatmentResultRecords;
  let usedContainers = [
  ...new Map(trr.filter(item=>item.containerNumber!=null)
    .map(item =>[
      item.containerNumber,
      {
        containerNumber: item.containerNumber,
        id: item.id
      }
    ])
  ).values()
];
  return usedContainers

} 
getContainerNumbers = (currentJob, id, currentTreatmentResultRecord) => {
    console.log('currentJobTRRForms', currentJob);

    var usedContainers = this.containerIsUsed(currentJob);
    console.log('usedContainer',usedContainers)

    var markingOptions = currentJob.treatmentTypeDetails.markings;

    var markings2 = markingOptions.map((marking) => {
        const value = `${marking.containerNumber} & ${marking.sealNumber}`;
        return {
            value: value,
            label: value
        };
    });
      if(currentTreatmentResultRecord.containerNumber != undefined && currentTreatmentResultRecord.containerNumber != ""){
        console.log("in undefined",currentTreatmentResultRecord)
      return markings2 = [{value:currentTreatmentResultRecord.containerNumber ,label:currentTreatmentResultRecord.containerNumber}]
    }
    console.log('markings2', markings2);

  markings2 = markings2.filter(
    item =>
        item.value != null &&
        !usedContainers.some(
            container =>
                container.containerNumber.replace(/\s+/g, '') ===
                item.value.replace(/\s+/g, '')
        )
);

    return markings2;
}

   /*getContainerNumbers=(currentJob,id,currentTreatmentResultRecord)=>{
    console.log('currentJobTRRForms',currentJob)
     var usedContainers =  this.containerIsUsed(currentJob) //used containers
 var markingOptions = currentJob.treatmentTypeDetails.markings; //all containers
   // const doubled = markingOptions.map((marking) =>  marking.containerNumber);
   const doubled = markingOptions.map((marking) =>  marking);
   console.log('doubled',doubled)
     let markings2=[] ;
       if(currentTreatmentResultRecord.containerNumber != undefined ){
        console.log("in undefined",currentTreatmentResultRecord)
      return markings2 = [{value:currentTreatmentResultRecord.containerNumber ,label:currentTreatmentResultRecord.containerNumber}]
    }
    for(var i =0;i<doubled.length;i++){
       var containerNumber ={value:'' ,label:''}
        containerNumber.value = doubled[i];
        containerNumber.label = doubled[i];
       markings2.push(containerNumber)
     }/*
markings2 = markings2
  .filter(
    item =>
      item.value != null &&
      !usedContainers.some(
        container => container.containerNumber === item.value 
      )
  )
  console.log('markings2',markings2)
     return markings2;
}*/
  render() {
    const {
      //  onSubmit,
      actions,
      showMonitoring,
      accordionActiveItemIndex,
      currentTreatmentResultRecord,
      jobType,
      currentJob,
      initialValues,
      dispatch,
      formValues,
      handleSubmit,
    } = this.props;


    const standardId = currentJob.treatmentDetails.standardId
      ? currentJob.treatmentDetails.standardId
      : null;
    const commodity = currentJob.treatmentTypeDetails.commodity
      ? currentJob.treatmentTypeDetails.commodity
      : null;
    const isApplesJapan = isExportOtherMBApples(
      jobType,
      currentJob.treatmentDetails.treatmentTypeId,
      commodity,
      standardId,
    );
    let { isCoveredContainer } = this.props;
    let currentIsCoveredContainer = isCoveredContainer;
    if (isCoveredContainer != undefined) {
      isCoveredContainer = currentIsCoveredContainer;
    } else {
      isCoveredContainer = false;
    }
    return (
      <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
        <Accordion
          className={styles.accordion}
          open={[accordionActiveItemIndex]}
        >
          <AccordionItem title="Start Details">
            <TreatmentResultRecordsStartDetailsSection
              actions={actions}
              commodity={commodity}
              standardId={standardId}
            />
          </AccordionItem>
          {showMonitoring && (
            <AccordionItem title="Monitoring" className={styles.monitoring}>
              <TreatmentResultRecordsMonitoringSection
                actions={actions}
                initialValues={currentTreatmentResultRecord}
                containerNumbers={isImportOrExportAndContainer(jobType)? this.getContainerNumbers(currentJob,initialValues.id,currentTreatmentResultRecord):[]}
              />
            </AccordionItem>
          )}
          <AccordionItem
            title={
              isSulfurylFlouride(currentJob.treatmentDetails.treatmentTypeId) ||
              isEthylFormate(currentJob.treatmentDetails.treatmentTypeId) || isImportOrExportContainerAndMethylBromide(jobType,currentJob.treatmentDetails.treatmentTypeId)
                ? 'End Details'
                : !isMBLogsInHold(jobType) && !isApplesJapan
                ? 'Uncovering Details'
                : 'Venting Details'
            }
          >
            <TreatmentResultRecordsUncoveringSection
              currentJob={currentJob}
              jobType={jobType}
              actions={actions}
              isCoveredContainer={isCoveredContainer}
              currentTreatmentResultRecord={currentTreatmentResultRecord}
            />
          </AccordionItem>
        </Accordion>
      </Form>
    );
  }
}

TreatmentResultRecordsForm.propTypes = propTypes;

export default compose(
  withShowMonitoring,
  withAccordionActiveItemIndex,
)(TreatmentResultRecordsForm);
